'use client';
import { ListOptions } from '@/components/data/dataType';
import React from 'react';
import Select from '../ui/Select';

export const FormSelect: React.FC<{
    field: string;
    options: ListOptions[];
    parentValue?: string | number | undefined;
    placeholder?: string;
    value: string | number | undefined | null;
    onChange: (value: string | number | undefined | null) => void;
}> = ({ field, options, placeholder, value, onChange }) => {
    return (
        <Select
            defaultValue={value && value.toString()}
            name={field}
            onChange={(value: string | number | null) => {
                if (value !== undefined) {
                    onChange(value);
                }
            }}
            options={options}
            placeholder={placeholder || 'Select an option'}
        />
    );
};
